import { render, staticRenderFns } from "./TrigSeriesViz.vue?vue&type=template&id=49f80ccb&scoped=true"
import script from "./TrigSeriesViz.vue?vue&type=script&lang=js"
export * from "./TrigSeriesViz.vue?vue&type=script&lang=js"
import style0 from "./TrigSeriesViz.vue?vue&type=style&index=0&id=49f80ccb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f80ccb",
  null
  
)

export default component.exports